var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgQuickbooks = function SvgQuickbooks(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6673 8.21647C14.6673 11.8984 11.6825 14.8831 8.00065 14.8831C4.31875 14.8831 1.33398 11.8984 1.33398 8.21647C1.33398 4.53457 4.31875 1.5498 8.00065 1.5498C11.6825 1.5498 14.6673 4.53457 14.6673 8.21647Z",
    fill: "#2CA01C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.81574 5.61212H10.1784C11.5805 5.61212 12.7172 6.7782 12.7172 8.21662C12.7172 9.655 11.5805 10.8211 10.1784 10.8211H8.36393V3.82617C8.88471 3.82617 9.30689 4.25926 9.30689 4.79356V9.85371H10.1784C11.0583 9.85371 11.7742 9.11933 11.7742 8.21662C11.7742 7.31392 11.0583 6.57951 10.1784 6.57951H9.81574V5.61212ZM5.82454 10.8207C4.42243 10.8207 3.28581 9.65464 3.28581 8.21624C3.28581 6.77784 4.42243 5.61173 5.82454 5.61173H7.63903V12.6067C7.11825 12.6067 6.69607 12.1735 6.69607 11.6393V6.57912H5.82454C4.94463 6.57912 4.22877 7.3135 4.22877 8.21624C4.22877 9.11892 4.94463 9.85333 5.82454 9.85333H6.18722V10.8207H5.82454Z",
    fill: "white"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgQuickbooks);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "quickbooks.08a9a0f7934dfa7ed71ac7256ea5f39f.svg";